import { createStructuredSelector } from "reselect";
import {
    HOSPITAL_EVALUATION_LIST,
    HOSPITAL_EVALUATION_LIST_SUCCESS,
    HOSPITAL_EVALUATION_LIST_ERROR,
    HOSPITAL_EVALUATION_DESTINATION,
    HOSPITAL_EVALUATION_DESTINATION_SUCCESS,
    HOSPITAL_EVALUATION_DESTINATION_ERROR,
    HOSPITAL_EVALUATION_AREA,
    HOSPITAL_EVALUATION_AREA_SUCCESS,
    HOSPITAL_EVALUATION_AREA_ERROR,
    HOSPITAL_EVALUATION_JOB,
    HOSPITAL_EVALUATION_JOB_SUCCESS,
    HOSPITAL_EVALUATION_JOB_ERROR,
    HOSPITAL_EVALUATION_ADD_MODAL_SET,
    HOSPITAL_EVALUATION_ADD_CHANGE_SET,
    HOSPITAL_EVALUATION_ADD,
    HOSPITAL_EVALUATION_ADD_SUCCESS,
    HOSPITAL_EVALUATION_ADD_ERROR,
    HOSPITAL_EVALUATION_TAB_SET,
    HOSPITAL_EVALUATION_CAPACITY_INSTALL,
    HOSPITAL_EVALUATION_CAPACITY_INSTALL_SUCCESS,
    HOSPITAL_EVALUATION_CAPACITY_INSTALL_ERROR,
    HOSPITAL_EVALUATION_INFRASTRUCTURE,
    HOSPITAL_EVALUATION_INFRASTRUCTURE_SUCCESS,
    HOSPITAL_EVALUATION_INFRASTRUCTURE_ERROR,
    HOSPITAL_EVALUATION_HUMAN_TALENT,
    HOSPITAL_EVALUATION_HUMAN_TALENT_SUCCESS,
    HOSPITAL_EVALUATION_HUMAN_TALENT_ERROR,
    HOSPITAL_EVALUATION_PRODUCTION,
    HOSPITAL_EVALUATION_PRODUCTION_SUCCESS,
    HOSPITAL_EVALUATION_PRODUCTION_ERROR,
    HOSPITAL_EVALUATION_AVAILABILITY,
    HOSPITAL_EVALUATION_AVAILABILITY_SUCCESS,
    HOSPITAL_EVALUATION_AVAILABILITY_ERROR

} from "../../actions";

export const NAME = 'hnEvaluation';

export const HospitalEvaluationList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: HOSPITAL_EVALUATION_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const HospitalEvaluationListSuccess = (data) => ({
    type: HOSPITAL_EVALUATION_LIST_SUCCESS,
    payload: data
});

export const HospitalEvaluationListError = (error) => ({
    type: HOSPITAL_EVALUATION_LIST_ERROR,
    payload: error
});

export const HospitalEvaluationDestination = (data) => ({
    type: HOSPITAL_EVALUATION_DESTINATION,
    payload: data
});

export const HospitalEvaluationDestinationSuccess = (data) => ({
    type: HOSPITAL_EVALUATION_DESTINATION_SUCCESS,
    payload: data
});

export const HospitalEvaluationDestinationError = (error) => ({
    type: HOSPITAL_EVALUATION_DESTINATION_ERROR,
    payload: error
});

export const HospitalEvaluationArea = (data) => ({
    type: HOSPITAL_EVALUATION_AREA,
    payload: data
});

export const HospitalEvaluationAreaSuccess = (data) => ({
    type: HOSPITAL_EVALUATION_AREA_SUCCESS,
    payload: data
});

export const HospitalEvaluationAreaError = (error) => ({
    type: HOSPITAL_EVALUATION_AREA_ERROR,
    payload: error
});

export const HospitalEvaluationJob = (data) => ({
    type: HOSPITAL_EVALUATION_JOB,
    payload: data
});

export const HospitalEvaluationJobSuccess = (data) => ({
    type: HOSPITAL_EVALUATION_JOB_SUCCESS,
    payload: data
});

export const HospitalEvaluationJobError = (error) => ({
    type: HOSPITAL_EVALUATION_JOB_ERROR,
    payload: error
});

export const HospitalEvaluationAddModalSet = (data) => ({
    type: HOSPITAL_EVALUATION_ADD_MODAL_SET,
    payload: data
});

export const HospitalEvaluationAddChangeSet = (data) => ({
    type: HOSPITAL_EVALUATION_ADD_CHANGE_SET,
    payload: data
});

export const HospitalEvaluationAdd = (page, num_page, orderBy, filters, data) => ({
    type: HOSPITAL_EVALUATION_ADD,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const HospitalEvaluationAddSuccess = (message) => ({
    type: HOSPITAL_EVALUATION_ADD_SUCCESS,
    payload: message
});

export const HospitalEvaluationAddError = (error) => ({
    type: HOSPITAL_EVALUATION_ADD_ERROR,
    payload: error
});

export const HospitalEvaluationTabSet = (data) => ({
    type: HOSPITAL_EVALUATION_TAB_SET,
    payload: data
});

export const HospitalEvaluationCapacityInstall = (data) => ({
    type: HOSPITAL_EVALUATION_CAPACITY_INSTALL,
    payload: data
});

export const HospitalEvaluationCapacityInstallSuccess = (data) => ({
    type: HOSPITAL_EVALUATION_CAPACITY_INSTALL_SUCCESS,
    payload: data
});

export const HospitalEvaluationCapacityInstallError = (error) => ({
    type: HOSPITAL_EVALUATION_CAPACITY_INSTALL_ERROR,
    payload: error
});

export const HospitalEvaluationInfrastructure = (data) => ({
    type: HOSPITAL_EVALUATION_INFRASTRUCTURE,
    payload: data
});

export const HospitalEvaluationInfrastructureSuccess = (data) => ({
    type: HOSPITAL_EVALUATION_INFRASTRUCTURE_SUCCESS,
    payload: data
});

export const HospitalEvaluationInfrastructureError = (error) => ({
    type: HOSPITAL_EVALUATION_INFRASTRUCTURE_ERROR,
    payload: error
});

export const HospitalEvaluationHumanTalent = (data) => ({
    type: HOSPITAL_EVALUATION_HUMAN_TALENT,
    payload: data
});

export const HospitalEvaluationHumanTalentSuccess = (data) => ({
    type: HOSPITAL_EVALUATION_HUMAN_TALENT_SUCCESS,
    payload: data
});

export const HospitalEvaluationHumanTalentError = (error) => ({
    type: HOSPITAL_EVALUATION_HUMAN_TALENT_ERROR,
    payload: error
});

export const HospitalEvaluationProduction = (data) => ({
    type: HOSPITAL_EVALUATION_PRODUCTION,
    payload: data
});

export const HospitalEvaluationProductionSuccess = (data) => ({
    type: HOSPITAL_EVALUATION_PRODUCTION_SUCCESS,
    payload: data
});

export const HospitalEvaluationProductionError = (error) => ({
    type: HOSPITAL_EVALUATION_PRODUCTION_ERROR,
    payload: error
});

export const HospitalEvaluationAvailability = (data) => ({
    type: HOSPITAL_EVALUATION_AVAILABILITY,
    payload: data
});

export const HospitalEvaluationAvailabilitySuccess = (data) => ({
    type: HOSPITAL_EVALUATION_AVAILABILITY_SUCCESS,
    payload: data
});

export const HospitalEvaluationAvailabilityError = (error) => ({
    type: HOSPITAL_EVALUATION_AVAILABILITY_ERROR,
    payload: error
});

const hnEvaluation = (state) => state[NAME];

export const HospitalEvaluationSelector = createStructuredSelector({
    hnEvaluation
})